import React, { useState } from 'react';
import PropTypes from 'prop-types';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import sendDataToMobileApp, { SR_MOBILE_APP_ACTION_TYPE_OPEN_URL } from 'client/helpers/sendDataToMobileApp';

import { formatPrice } from 'common/formatters';

import SrPriceComparisonCard,
{
  SR_PRICE_COMPARISON_CARD_COLOR_GREEN,
  SR_PRICE_COMPARISON_CARD_COLOR_ORANGE,
} from 'client/components/SrPriceComparisonCard/SrPriceComparisonCard';
import SrListingLowerPriceModal from 'client/components/SrListingLowerPriceModal/SrListingLowerPriceModal';

const SrComparativeMarketAnalysisCard = ({
  listing,
  appUrl,
  userAgent,
  isRentPriceTooHigh,
  dispatch,
  onLowerRentPrice,
  partner,
  isAdmin,
}) => {
  const isMobileApp = isUserAgentMobileApp(userAgent);
  const [showLowerPriceModal, setShowLowerPriceModal] = useState(false);

  return (
    <>
      <SrPriceComparisonCard
        colorType={
          isRentPriceTooHigh
            ? SR_PRICE_COMPARISON_CARD_COLOR_ORANGE
            : SR_PRICE_COMPARISON_CARD_COLOR_GREEN
        }
        priceLeft={listing.price}
        priceLeftLabel='Your rent price'
        priceRight={listing.comparativeMarketAnalysisRentPrice}
        priceRightLabel='CMA suggested rate'
        descriptionTitle={
          listing.comparativeMarketAnalysisNotes
            ? 'Notes from Sunroom Leasing'
            : null
        }
        descriptionText={listing.comparativeMarketAnalysisNotes}
        buttonText='View Report'
        onButtonClick={() => {
          if (isMobileApp) {
            sendDataToMobileApp({
              actionType: SR_MOBILE_APP_ACTION_TYPE_OPEN_URL,
              url: `${appUrl}/pdf-viewer?pdfUrl=${
                encodeURIComponent(listing.comparativeMarketAnalysisPdfUrl)
              }`,
            });
          }
          else {
            global.open(
              `${appUrl}/pdf-viewer?pdfUrl=${
                encodeURIComponent(listing.comparativeMarketAnalysisPdfUrl)
              }`, '_blank'
            );
          }
        }}
        ctaText={isRentPriceTooHigh
          ? `Lower the Price to ${formatPrice(listing.comparativeMarketAnalysisRentPrice)}`
          : null
        }
        onCtaClick={() => setShowLowerPriceModal(true)}
        isAdmin={isAdmin}
        partnerId={partner.id}
        partnerSlug={partner.slug}
        listingId={listing.id}
        isRentPriceTooHigh={isRentPriceTooHigh}
        cmaDiscussed={listing.comparativeMarketAnalysisDiscussed}
        cmaDiscussionNotes={listing.comparativeMarketAnalysisDiscussionNotes}
        cmaDiscussedAt={listing.comparativeMarketAnalysisDiscussedAt}
        cmaDiscussedBy={listing.comparativeMarketAnalysisDiscussedByUser}
      />
      {showLowerPriceModal && listing && (
        <SrListingLowerPriceModal
          listing={listing}
          dispatch={dispatch}
          onClose={() => setShowLowerPriceModal(false)}
          onLowerRentPrice={onLowerRentPrice}
        />
      )}
    </>
  );
};

SrComparativeMarketAnalysisCard.propTypes = {
  listing: PropTypes.object.isRequired,
  partner: PropTypes.object.isRequired,
  appUrl: PropTypes.string.isRequired,
  userAgent: PropTypes.object.isRequired,
  isRentPriceTooHigh: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  onLowerRentPrice: PropTypes.func.isRequired,
};

SrComparativeMarketAnalysisCard.displayName = 'SrComparativeMarketAnalysisCard';

export default SrComparativeMarketAnalysisCard;
